export default {
  title: 'Novo Perfil',
  title_edit: 'Editando Perfil'
}
